export const CANDIDATE_REPORTS = {
  NO_SHOW: {
    text: "CORE.MODELS.CANDIDATE_REPORTS.@NO_SHOW_REPORT",
    icon: "fad fa-ghost",
    code: "no_show_count",
  },
  CANCELATION: {
    text: "CORE.MODELS.CANDIDATE_REPORTS.@CANCELATION_REPORT",
    icon: "fad fa-calendar-xmark",
    code: "cancelation_24h_count",
  },
  BAD_BEHAVIOUR: {
    text: "CORE.MODELS.CANDIDATE_REPORTS.@BAD_BEHAVIOUR_REPORT",
    icon: "fad fa-hand",
    code: "bad_behaviour_count",
  },
};
